import {defineStore} from 'pinia'
import type {OutputChatChannel} from "~/models"

export const useChatChannelsStore = defineStore('chatChannels', {
    state: () => ({
        channels: new Map<number, OutputChatChannel>(),
    }),
    getters: {
        channelsList: (state: any) => {
            return Array.from(state.channels.values() as OutputChatChannel[])
                .sort((a, b) => a.name.localeCompare(b.name))
        }
    },
    actions: {
        async load() {
            const permissionsStore = usePermissionsStore()
            if (permissionsStore.permissions.length === 0) {
                await permissionsStore.load()
            }
            if (!permissionsStore.permissions.includes('chat_page:view')) {
                return
            }

            const channelsList = await useApi().getChatChannels()
            const newChannels = new Map()
            for (const item of channelsList) {
                newChannels.set(item.id, item)
            }
            this.channels = newChannels
        },

        handleCentrifugeNotification(message: {
            type: string,
            operation: string,
            payload: OutputChatChannel
        }) {

            // Якщо прийшло щось інше, не обробляємо
            if (!message || message.type !== 'chat_channels') {
                return
            }

            const {operation, payload} = message
            if (!payload || !payload.id) {
                return
            }

            switch (operation) {
                case 'insert':
                    // Додаємо новий канал у масив
                    this.channels.set(payload.id, payload)
                    break

                case 'update':
                    // Знаходимо канал по id і оновлюємо
                    this.channels.set(payload.id, payload)
                    break

                case 'delete':
                    // Фільтруємо непотрібний канал
                    this.channels.delete(payload.id)
                    break
            }
        }
    },
})